import airportTransferReducer from '../features/airport-transfer/redux/reducer';
import atCancellationReducer from '../features/at-cancellation/redux/reducer';
import cancellationReducer from '../features/cancellation/redux/reducer';
import { combineReducers } from 'redux';
import commonReducer from '../features/common/redux/reducer';
import cuponeraReducer from '../features/cuponera/redux/reducer';
import enRoutesReducer from '../features/en-routes/redux/reducer';
import esRoutesReducer from '../features/es-routes/redux/reducer';
import examplesReducer from '../features/examples/redux/reducer';
import homeReducer from '../features/home/redux/reducer';
import myAccountReducer from '../features/my-account/redux/reducer';
import pagesReducer from '../features/pages/redux/reducer';
import pbPaymentDetailsReducer from '../features/pb-payment-details/redux/reducer';
import pbServiceListReducer from '../features/pb-service-list/redux/reducer';
import { routerReducer } from 'react-router-redux';
import siteMapReducer from '../features/site-map/redux/reducer';
import themesReducer from '../features/themes/redux/reducer';
import trenCentralReducer from '../features/tren-central/redux/reducer';
import terminalBookingReducer from '../features/terminal-booking/redux/reducer';

// NOTE 1: DO NOT CHANGE the 'reducerMap' name and the declaration pattern.
// This is used for Rekit cmds to register new features, remove features, etc.
// NOTE 2: always use the camel case of the feature folder name as the store branch name
// So that it's easy for others to understand it and Rekit could manage them.

const reducerMap = {
  router: routerReducer,
  home: homeReducer,
  common: commonReducer,
  examples: examplesReducer,
  pbServiceList: pbServiceListReducer,
  pbPaymentDetails: pbPaymentDetailsReducer,
  myAccount: myAccountReducer,
  cancellation: cancellationReducer,
  pages: pagesReducer,
  siteMap: siteMapReducer,
  airportTransfer: airportTransferReducer,
  trenCentral: trenCentralReducer,
  esRoutes: esRoutesReducer,
  enRoutes: enRoutesReducer,
  atCancellation: atCancellationReducer,
  themes: themesReducer,
  cuponera: cuponeraReducer,
  terminalBooking: terminalBookingReducer,
};

export default combineReducers(reducerMap);



// WEBPACK FOOTER //
// ./src/common/rootReducer.js